"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CacheManager = void 0;
const ImmutableDataCache_1 = require("../../utils/ImmutableDataCache");
const CachingDataService_1 = require("./CachingDataService");
class CacheManager {
    constructor() {
        this._caches = new Map();
        this._caches.set(CachingDataService_1.DataSource.Avatar, new ImmutableDataCache_1.ImmutableDataCache(CachingDataService_1.DataSource[CachingDataService_1.DataSource.Avatar], {
            maxEntries: 200,
            maxAgeSeconds: 28 * 24 * 60 * 60 // 4 weeks
        }));
        this._caches.set(CachingDataService_1.DataSource.MediaMessage, new ImmutableDataCache_1.ImmutableDataCache(CachingDataService_1.DataSource[CachingDataService_1.DataSource.MediaMessage], {
            maxEntries: 50,
            maxAgeSeconds: 7 * 24 * 60 * 60 // 1 week
        }));
    }
    tryGet(src, key) {
        return __awaiter(this, void 0, void 0, function* () {
            const cache = this._caches.get(src);
            if (!cache) {
                return null;
            }
            return yield cache.tryGet(key);
        });
    }
    put(src, key, data) {
        return __awaiter(this, void 0, void 0, function* () {
            const cache = this._caches.get(src);
            if (!cache) {
                return false;
            }
            return yield cache.put(key, data);
        });
    }
    scavenge() {
        return __awaiter(this, void 0, void 0, function* () {
            for (const cache of this._caches.values()) {
                yield cache.scavenge();
            }
        });
    }
}
exports.CacheManager = CacheManager;
